import { GridOffset } from "@insite/mobius/GridContainer";
import { BillToSelectionStylesStyles } from "@store/Components/Customer/BillToSelection";
import { COLORS } from "@store/theme/common/design";
import { css } from "styled-components";

export const sharedStyled: BillToSelectionStylesStyles = {
    selectorDynamicDropdown: {
        css: css`
            .is-selected {
                background-color: ${COLORS.table.selected} !important;

                td {
                    color: ${COLORS.white};
                }
            }
        `,
    },
    customerRow: {
        css: css`
            &:hover {
                background-color: ${COLORS.table.hover};
                cursor: pointer;
            }
        `,
    },
    selectionTitle: {
        forwardAs: "h2",
        variant: "h2",
    },
    searchGridItem: {
        width: [12, 12, 12, 4, 4],
    },
    customerTableColHeader: {
        css: css`
            width: 30%;
        `,
    },
    radioRowHeader: {
        css: css`
            width: 5%;
        `,
    },
    idRowHeader: {
        css: css`
            width: 10%;
        `,
    },
    addressTableColHeader: {
        css: css`
            width: 40%;
        `,
    },
    cityTableColheader: {
        css: css`
            width: 15%;
        `,
    },
    table: {
        css: css`
            width: 100%;
        `,
    },
    contentWrapper: {
        css: css`
            width: 100%;
            display: block;
            margin-bottom: 15px;
        `,
    },
    tableWrapper: {
        css: css`
            width: 100%;
            overflow: auto;
        `,
    },
    container: {
        gap: 0,
        css: css`
            ${GridOffset} {
                width: 100%;
                margin: 5px 0 10px;
            }
        `,
    },
};
